interface ViewerLaunchMessage {
  phase: 'viewer_ready' | 'launch_context' | 'applications';
  outcome: 'completed' | 'failed';
  reported: boolean;
  httpStatus?: number;
}

/** Existing SDK protocol; readiness works independently of telemetry availability. */
export function postViewerLaunchMessage(payload: ViewerLaunchMessage): void {
  try {
    const parentOrigin = new URLSearchParams(window.location.search).get('parentOrigin');
    if (window.parent === window || !parentOrigin) return;
    const target = new URL(parentOrigin);
    if (!/^https?:$/.test(target.protocol)) return;
    window.parent.postMessage({ type: 'LAUNCH_DIAGNOSTIC', payload }, target.origin);
  } catch {
    // Messaging must not interrupt standalone viewing or launch fallbacks.
  }
}

export function notifyViewerReady(): void {
  // Older SDKs relay messages with reported=false to NR. Readiness is never telemetry.
  postViewerLaunchMessage({ phase: 'viewer_ready', outcome: 'completed', reported: true });
}
